import {Component, inject, OnInit} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {CartService} from '../services/cart';
import {Shared} from '../services/shared';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-success',
  imports: [RouterLink, TranslatePipe],
  templateUrl: './success.html',
  styleUrl: './success.scss'
})
export class Success implements OnInit {
  router = inject(Router)
  cartService = inject(CartService)
  order: any;


  constructor() {
    const nav = this.router.getCurrentNavigation();
    this.order = nav?.extras.state?.['order'];
  }

  ngOnInit() {
    this.cartService.clear()
  }
}
